import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "page-container",
  id: "home-container"
}
const _hoisted_2 = { class: "fixed w-full h-[calc(100dvh)] h-screen z-[-1]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fixed w-full h-full bg-gradient-to-r from-[#000000]/60 via-[#080F0F]/60 to-[#0A241A]/60" }, null, -1)
const _hoisted_4 = {
  id: "mainbg-grayscale",
  class: "fixed object-cover w-full h-full grayscale transition-opacity duration-1000 opacity-0"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  id: "mainbg-overlay",
  class: "fixed w-full h-full bg-white bg-opacity-70 opacity-0 transition-opacity duration-1000"
}, null, -1)
const _hoisted_6 = {
  id: "home",
  class: "w-full min-h-[calc(100dvh)] h-screen flex flex-col p-5 md:p-10"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"h-12\"></div><div class=\"flex-grow flex flex-col items-center justify-center sm:mb-20\"><div class=\"text-center text-white\"><h2 class=\"font2 text-5xl\"><span class=\"ani-top inline-block\">Unconventional</span> <span class=\"ani-top inline-block\">minds,</span> <span class=\"ani-top inline-block\">pursuing</span> <span class=\"ani-top inline-block\">excellence.</span></h2></div></div>", 2)
const _hoisted_9 = { class: "mx-auto" }
const _hoisted_10 = {
  id: "mission",
  class: "w-full min-h-[calc(100dvh)] h-screen flex flex-col p-5 md:p-10 bg-gradient-to-r from-[#091510] to-[#0D3123]"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"h-12\"></div><div class=\"flex-grow flex flex-col items-center justify-center sm:mb-20\"><div class=\"text-center text-white\"><h3 class=\"font1 text-xl mb-5 uppercase ani-top\">Our mission</h3><p class=\"font2 text-2xl max-w-2xl ani-top\">We live and breathe real estate and are driven to deliver exceptional returns for our valued investors. Committed to a relentless pursuit of excellence, Zinc embodies a culture of dedicated professionals who thrive on pushing boundaries, innovative thinking, and swift actions.</p></div></div>", 2)
const _hoisted_13 = { class: "mx-auto" }
const _hoisted_14 = {
  id: "usp",
  class: "w-full min-h-[calc(100dvh)] h-screen flex flex-col p-5 md:p-10"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "h-24" }, null, -1)
const _hoisted_16 = { class: "flex-grow flex flex-col items-center justify-center sm:mb-20" }
const _hoisted_17 = { class: "text-center flex flex-wrap justify-center color-[#081010]" }
const _hoisted_18 = { class: "w-full sm:w-1/2 lg:w-1/5 p-4" }
const _hoisted_19 = { class: "w-full sm:w-1/2 lg:w-1/5 p-4" }
const _hoisted_20 = { class: "w-full sm:w-1/2 lg:w-1/5 p-4" }
const _hoisted_21 = { class: "w-full sm:w-1/2 lg:w-1/5 p-4" }
const _hoisted_22 = { class: "w-full sm:w-1/2 lg:w-1/5 p-4" }
const _hoisted_23 = { class: "mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResponsiveVideo = _resolveComponent("ResponsiveVideo")!
  const _component_SvgIconNext = _resolveComponent("SvgIconNext")!
  const _component_CountingNumber = _resolveComponent("CountingNumber")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ResponsiveVideo),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ResponsiveVideo)
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_SvgIconNext, { target: "#mission" })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_SvgIconNext, { target: "#usp" })
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_CountingNumber, {
              from: 2000,
              to: 2016,
              duration: 3,
              label: "EST."
            }, {
              before: _withCtx(() => []),
              after: _withCtx(() => []),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_CountingNumber, {
              from: 650,
              to: 815,
              duration: 3,
              label: "Assets under management"
            }, {
              before: _withCtx(() => [
                _createTextVNode("€")
              ]),
              after: _withCtx(() => [
                _createTextVNode("M.")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_CountingNumber, {
              from: 70,
              to: 100,
              duration: 3,
              label: "Loans Under Management"
            }, {
              before: _withCtx(() => [
                _createTextVNode("€")
              ]),
              after: _withCtx(() => [
                _createTextVNode("M.")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_CountingNumber, {
              from: 150,
              to: 190,
              duration: 3,
              label: "sqm Total GFA developments"
            }, {
              before: _withCtx(() => []),
              after: _withCtx(() => [
                _createTextVNode("K.")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_CountingNumber, {
              from: 20,
              to: 38,
              duration: 3,
              label: "Number of Properties"
            }, {
              before: _withCtx(() => []),
              after: _withCtx(() => []),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_SvgIconNext, {
          target: "#home",
          mode: "mode-up",
          color: "#081010"
        })
      ])
    ])
  ]))
}